export default __webpack_public_path__ + "static/media/cloth1.49977705.webp";